import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";

/**
 * @file Created on Thu Jan 03 2019
 * @author LZe
 */
import * as React from 'react';
import Button, { ButtonColor, ButtonSize } from '../../../controls/Button';
import Icon, { IconColor, IconType } from '../../../media/Icon';
import AgGrid from '../../AgGrid';
import { ExcelStyles } from './ExcelStyles';
import Filters from './filters';
/**
 * This component was created in order to complete LOG-4625
 * Provides export to excel of custom data
 */

var CustomExportToExcel =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(CustomExportToExcel, _React$PureComponent);

  function CustomExportToExcel(props) {
    var _this;

    _classCallCheck(this, CustomExportToExcel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CustomExportToExcel).call(this, props));
    _this.resetExport = _this.resetExport.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.renderClonedGrid = _this.renderClonedGrid.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.invokeExportInClonedGrid = _this.invokeExportInClonedGrid.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.downloadDataAndExportToExcel = _this.downloadDataAndExportToExcel.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.state = {
      renderClonedGrid: false,
      gridRows: []
    };
    return _this;
  }

  _createClass(CustomExportToExcel, [{
    key: "renderClonedGrid",
    value: function renderClonedGrid() {
      var _this2 = this;

      var selectedColumnDefs = this.props.getColumnDefs && this.props.getColumnDefs() || this.props.mainGridOptions.columnDefs || [];
      /** Unset cell renderers - they are not needed for virtual Ag-Grid. */

      var columnDefs = selectedColumnDefs.map(function (def) {
        function instanceOfGroupDef(object) {
          return 'children' in object;
        }

        if (!instanceOfGroupDef(def)) {
          def.cellRendererFramework = undefined;
          def.cellRenderer = undefined;
        }

        return def;
      });
      return React.createElement(AgGrid, {
        gridId: null,
        suppressPropertyNamesCheck: true,
        columnDefs: columnDefs,
        rowData: this.state.gridRows,
        excelStyles: this.props.mainGridOptions.excelStyles || ExcelStyles,
        onGridReady: function onGridReady(_ref) {
          var api = _ref.api,
              columnApi = _ref.columnApi;
          return _this2.invokeExportInClonedGrid(api, columnApi);
        },
        frameworkComponents: Object.assign({}, Filters)
      });
    }
  }, {
    key: "invokeExportInClonedGrid",
    value: function invokeExportInClonedGrid(api, colApi) {
      var params = this.props.excelExportParams; // Formates values

      params.processCellCallback = function (props) {
        var column = props.column,
            value = props.value; // TODO: PKr suggests that we should use valueGetter here instead of valueFormatter

        var colDef = column.getColDef(); // Normal and excel `valueFormatter` should have the same arguments.

        var normalizedParams = Object.assign({
          colDef: colDef,
          data: props.node ? props.node.data : {},
          node: props.node
        }, props);

        if (colDef.excel != null && colDef.excel.valueFormatter != null) {
          return colDef.excel.valueFormatter(normalizedParams);
        } else if (colDef.valueFormatter) {
          return colDef.valueFormatter(normalizedParams);
        }

        return value;
      }; // Remove action column from export


      params.columnKeys = this.props.columnApi.getAllDisplayedColumns().map(function (column) {
        var colDef = column.getColDef();

        if (colDef.excel && colDef.excel.hide) {
          return null;
        }

        return column.getColId();
      });
      api.setFilterModel(this.props.api.getFilterModel());
      api.setSortModel(this.props.api.getSortModel());
      api.exportDataAsExcel(params);
      this.props.api.hideOverlay();
      this.resetExport();
    }
  }, {
    key: "downloadDataAndExportToExcel",
    value: function downloadDataAndExportToExcel() {
      var _this3 = this;

      this.props.api.showLoadingOverlay();
      this.props.getRowData().then(function (data) {
        _this3.setState({
          renderClonedGrid: true,
          gridRows: data
        });
      }).catch(function (error) {
        console.error(error);

        _this3.props.api.hideOverlay();
      });
    }
  }, {
    key: "resetExport",
    value: function resetExport() {
      this.setState({
        renderClonedGrid: false,
        gridRows: []
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", {
        style: {
          padding: '10px 0'
        }
      }, React.createElement(Button, {
        onClick: this.downloadDataAndExportToExcel,
        buttonColor: ButtonColor.Light,
        buttonSize: ButtonSize.Tiny,
        iconButton: true
      }, React.createElement(Icon, {
        iconType: IconType.exportToExcel,
        iconColor: IconColor.Secondary
      })), React.createElement("div", {
        style: {
          display: 'none'
        }
      }, this.state.renderClonedGrid && this.renderClonedGrid()));
    }
  }]);

  return CustomExportToExcel;
}(React.PureComponent);

export { CustomExportToExcel as default };